<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      appId: undefined
    }
  },
  mounted() {
    
  },
  created() {
    this.appId = this.$route.params.appId
  }
}
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100vh;
}

* {
  font-family: "Poppins", sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/App.vue